<!--设备台账-->
<template>
  <div class="archivesBody">

    <!--右边-->
    <div class="archiverRigth">
      <div class="dataAreaTop">
        <div class="archiverTableOperating">
          <div>
            <el-date-picker v-model="searchDate" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </div>
          <!-- <div style="width: 20%;">
                        <el-input v-model="search" size="medium" placeholder="输入关键字搜索" />
                    </div> -->
          <!-- <el-button type="primary" plain size='small' style='margin-left: 10px;' @click="showDeviceDialog()">
                        添加</el-button> -->
          <el-button type="primary" size='small' @click="uploadExcel" style='margin-left: 10px;'>
            上传Excel</el-button>
          <el-button type="danger" plain size='small' @click="batchDeletion()"
            style='margin-left: 10px; margin-right: 20px;'>批量删除
          </el-button>
          <!-- <el-button type="primary" size='small' @click="exportExcel" style='margin-right: 20px;'>
                        导出Excel</el-button> -->
          <el-button @click="demoClick">测试</el-button>
        </div>
      </div>


      <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls"
        @change="handleUploadExcelClick" v-show="false" name="file">
      <div class="dataAreaBottom">
        <el-table :data="dataList" border style="width: 100%" @selection-change="handleSelectionChange"
          :row-key="getRowKey">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号">
          </el-table-column>
          <el-table-column type="selection" width="55" :reserve-selection="true">
          </el-table-column>
          <!-- <el-table-column label="工程名称" prop="projectName">
                    </el-table-column> -->
          <!-- <el-table-column label="图号" prop="drawingNo">
                    </el-table-column>
                    <el-table-column label="型号" prop="modelNo">
                    </el-table-column> -->
          <el-table-column label="存货编码" prop="stockNo">
          </el-table-column>
          <el-table-column label="存货名称" prop="stockName">
          </el-table-column>
          <el-table-column label="规格型号" prop="specifications">
          </el-table-column>
          <el-table-column label="数量（台）" prop="num">
          </el-table-column>
          <el-table-column label="单价" prop="unitPrice">
          </el-table-column>
          <el-table-column label="金额" prop="amount">
          </el-table-column>
          <el-table-column label="箱体尺寸" prop="boxSize">
          </el-table-column>
          <el-table-column label="备注" prop="remark">
          </el-table-column>
          <el-table-column label="操作人" prop="userName">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" :formatter="formatTime">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width='300'>
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showQRCodeImg(scope.row)">二维码</el-button>
              <el-button type="primary" size="mini" @click="showDetailDialog(scope.row)">相关文件</el-button>
              <!-- <el-button type="primary" size='mini' @click='showDeviceDialog(scope.row)'>编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 100%;display: flex;align-items: center;justify-content: flex-end;height: 5%;">
          <el-pagination background layout="prev, pager, next" :total="total" @current-change='clickChange'
            @prev-click="prevClick" @next-click="nextClick">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 工程设备扫码弹出层 -->
    <el-dialog :title="deviceDialogTitle" :visible.sync="deviceVisible" @closed="deviceDialogClosed" width="500px">
      <el-form ref="deviceScanCodeform" :model="deviceScanCodeform" label-width="80px" :rules="deviceScanCodeformRules">
        <!-- <el-form-item label="工程名称" prop="projectName">
                    <el-input v-model="deviceScanCodeform.projectName" :disabled="disabled"></el-input>
                </el-form-item> -->
        <el-form-item label="图号" prop="drawingNo">
          <el-input v-model="deviceScanCodeform.drawingNo"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="modelNo">
          <el-input v-model="deviceScanCodeform.modelNo"></el-input>
        </el-form-item>
        <el-form-item label="存货编码" prop="stockNo">
          <el-input v-model="deviceScanCodeform.stockNo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="deviceVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="相关文件" :visible.sync="outerVisible" class="outerDialog">

      <!-- 文件上传 -->
      <el-dialog width="30%" title="添加" :visible.sync="innerVisible" append-to-body @closed="uploadDialogClosed">
        <el-form ref="form" :model="form" label-width="80px" :rules="formRules">
          <el-form-item label="文件命名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="文件上传" prop="flie">
            <el-upload class="upload-demo" ref="upload" :action='action' :on-remove="handleRemove"
              :file-list="uploadFileList" :on-change="handleChange" :auto-upload="false" :limit="1"
              :on-exceed="handleExceed" :data="updatePathForm" :on-success="handleUploadSuccess">
              <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="innerVisible = flase">取 消</el-button>
          <el-button type="primary" size="mini" @click="handleUpload">确 定</el-button>
        </div>
      </el-dialog>

      <div>
        <el-button type="primary" size="mini" @click="showUploadDialog()">添加</el-button>
      </div>

      <el-table :data="fileList">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column property="name" label="文件名称"></el-table-column>
        <el-table-column property="uploadDate" label="日期" width="200"></el-table-column>
        <el-table-column fixed="right" label="操作" width='300'>
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showPreview(scope.row)">预览</el-button>
            <el-button type="danger" size="mini" @click="handleDelFilePath(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>

    <!-- pdf预览 -->
    <el-dialog title="预览" :visible.sync="previewVisible" @closed="previewDialogClosed">
      <pdf v-for="i in numPages" :key="i" :src="resourcePreviewURL" :page="i"></pdf>
    </el-dialog>

    <!-- 二维码图片预览 -->
    <el-image-viewer v-if="isShowQRCodeImg" :on-close="closeViewer" :url-list="[qrcodeImg]" />

  </div>
</template>

<script type="text/javascript">
  import pdf from 'vue-pdf'
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

  const updatePathForm={
    // insert, delete
    action: 'insert',
    oldFilePath: null,
    newFilePath: null,
    id: null
  }

  export default {
    components: {pdf,ElImageViewer},
    data () {
      // 文件校验
      const validatorFile=(rule,value,callback) => {
        if(this.uploadFileList.length<1) {
          callback(new Error('请上传文件'))
        } else {
          callback()
        }
      }
      return {
        //过滤
        search: '',
        searchDate: [`${getDay(0)} 00:00:00`,`${getDay(0)} 23:59:59`],
        // 分页
        pageIndex: 1,
        size: 10,
        total: 0,
        // 选中列表
        selectItemList: [],
        disabled: false,
        updatePathForm: Object.assign({},updatePathForm),
        // 上传文件地址
        action: `${DWSystemSetting.baseURL}/deviceScanCode/updFilePath`,
        // 上传Excel地址
        action2: `${DWSystemSetting.baseURL}/deviceScanCode/uploadExcel`,
        // 工程设备扫描表单
        deviceScanCodeform: {
          // projectName: '',
          drawingNo: '',
          modelNo: '',
          stockNo: ''
        },
        // 文件上传列表
        uploadFileList: [],
        // 工程设备扫描弹出层
        deviceDialogTitle: '',
        deviceVisible: false,
        // 表格数据
        dataList: [],
        // 相关文件列表
        fileList: [],
        form: {
          name: '',
          // projectName: ''
          stockNo: ''
        },
        // 详情对话框
        outerVisible: false,
        // 文件上传对话框
        innerVisible: false,
        // 预览弹出层
        previewVisible: false,
        // 预览资源地址
        resourcePreviewURL: '',
        numPages: undefined,
        // 工程设备扫描表单校验规则
        deviceScanCodeformRules: {
          // projectName: [
          //     { required: true, message: '请输入工程名称', trigger: 'blur' },
          //     { pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '不能带有特殊符号', trigger: 'blur' }
          // ],
          drawingNo: [
            {required: true,message: '请输入图号',trigger: 'blur'},
          ],
          modelNo: [
            {required: true,message: '请输入型号',trigger: 'blur'},
          ],
          stockNo: [
            {required: true,message: '请输入存货编码',trigger: 'blur'},
          ]
        },
        // 文件上传表单校验规则
        formRules: {
          name: [
            {required: true,message: '请输入文件名称',trigger: 'blur'},
            {pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,message: '不能带有特殊符号',trigger: 'blur'}
          ],
          flie: [
            {required: true,validator: validatorFile,trigger: 'change'}
          ]
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end=new Date();
              const start=new Date();
              start.setTime(start.getTime()-3600*1000*24*7);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近一个月',
            onClick (picker) {
              const end=new Date();
              const start=new Date();
              start.setTime(start.getTime()-3600*1000*24*30);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近三个月',
            onClick (picker) {
              const end=new Date();
              const start=new Date();
              start.setTime(start.getTime()-3600*1000*24*90);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
        loading: false,
        uploadExcelVisible: false,
        isShowQRCodeImg: false,
        qrcodeImg: ''
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      this.initData()
    },
    destroyed () {},
    computed: {

    },
    watch: {
      pageIndex () {
        this.initData()
      },
      previewVisible (newData,oldData) {
        if(newData) {
          this.resourcePreviewURL.promise.then(pdf => {
            this.numPages=pdf.numPages;
          })
        }
      },
      searchDate () {
        this.initData()
      }
    },
    methods: {
      //初始化数据
      initData () {
        this.$api.deviceApi.getDeviceScanCodeList(this.pageIndex,this.size,this.searchDate[0],this.searchDate[1],res => {
          this.total=res.total
          this.dataList=res.data
        })
        // this.$api.deviceApi.getList('2022-07-01', 2, res => {
        //     console.log(res)
        // })
      },
      demoExport () {
        console.log(typeof (JSON.stringify(['AT.1KT3A1-进线柜1KT3主开关_正向有功电能'])))
        this.$api.deviceApi.demoExport('2022-07-01',['AT.1KT3A1-进线柜1KT3主开关_正向有功电能'],res => {
          console.log(res)
        })
      },
      // 导出Excal
      exportExcel () {
        if(isempty(this.selectItemList)) {
          this.$message({
            message: '请选中数据',
            type: 'warning'
          });
          return
        }
        let ids=''
        this.selectItemList.forEach((item,index) => {
          if(index+1==this.selectItemList.length) {
            ids+=item.id
          } else {
            ids+=item.id+','
          }
        })
        this.$confirm('此操作将所选数据导出Excel, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deviceApi.exportExcel(ids,res => {
            saveAs(`${DWSystemSetting.downloadUrl}${res}`,'工程设备扫码.xls')
          })
        })
      },
      change (e) {
        this.$forceUpdate()
      },
      // 翻页多选key
      getRowKey (row) {
        return row.id
      },
      // 多选数据发生变化的回调
      handleSelectionChange (val) {
        this.selectItemList=val
      },
      batchDeletion () {
        //批量删除
        if(isempty(this.selectItemList)) {
          this.$message({
            message: '请选中数据',
            type: 'warning'
          });
          return
        }
        let ids=''
        this.selectItemList.forEach((item,index) => {
          if(index+1==this.selectItemList.length) {
            ids+=item.id
          } else {
            ids+=item.id+','
          }
        })
        this.$confirm('此操作将删除所选数据, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deviceApi.deleteDeviceScanCode(ids,res => {
            this.initData()
          })
        })
      },
      // 翻页
      prevClick () {
        //上一页
        if(this.pageIndex==1) {
          this.$message('当前为第一页');
          return
        }
        this.pageIndex-=1
      },
      clickChange (index) {
        this.pageIndex=index
        //点击页数
      },
      nextClick () {
        if(this.pageIndex==Math.ceil(this.total/this.size)) {
          this.$message('当前为最后一页');
          return
        }
        this.pageIndex+=1
      },
      // 格式化时间
      formatTime (row,column,cellValue) {
        return new Date(row.createTime).format('yyyy-MM-dd')
      },
      // 文件状态改变时的回调
      handleChange (file) {
        this.uploadFileList.push(file)
        const l=file.name.split('.')
        const uploadFileType=l[l.length-1]
        const date=new Date()
        let year=date.getFullYear()
        let month=date.getMonth()+1
        let day=date.getDate()
        this.updatePathForm.newFilePath=`***/${year}/${month}/${day}/${this.form.stockNo}/${this.form.name}.${uploadFileType}`
      },
      // 文件上传
      handleUpload () {
        this.$refs['form'].validate((valid) => {
          if(valid) {
            this.$refs.upload.submit()
          }
        })
      },
      // 文件上传成功回调
      handleUploadSuccess (response,file,fileList) {
        // 更新主表格数据
        this.updTableList(response.data)
        // 更新相关文件列表数据
        this.updFileList(response.data)
        // 关闭文件上传弹出层
        this.innerVisible=false
        // 重置更新文件地址表单
        this.updatePathForm=Object.assign({},updatePathForm)
        this.updatePathForm.id=response.data.id

        this.$message({
          type: 'success',
          message: '文件上传成功!'
        })
      },
      // 文件上传失败回调
      handleUploadError (err,file,fileList) {
        this.$message({
          message: '文件上传失败，请联系管理员',
          type: 'error'
        })
      },
      // 保存工程设备扫码数据
      handleSave () {
        this.$refs['deviceScanCodeform'].validate((valid) => {
          if(valid) {
            this.$api.deviceApi.saveDeviceScanCode(this.deviceScanCodeform,res => {
              // 更新主表格数据
              this.initData()
              this.deviceVisible=false
            })
          } else {
            this.$message({message: '请输入正确的表单数据',type: 'error'})
            return false
          }
        })
      },
      // 关闭工程设备扫码弹出层回调
      deviceDialogClosed () {
        // 重置表单
        this.$refs['deviceScanCodeform'].resetFields()
      },
      // 文件列表移除文件回调
      handleRemove (file,list) {
        this.uploadFileList=[]
      },
      // 上传文件超出个数限制回调
      handleExceed () {
        this.$message.warning('当前限制上传1个文件');
      },
      // 打开弹出层
      showDeviceDialog (row) {
        this.deviceVisible=true
        if(row) {
          this.deviceDialogTitle='编辑'
          this.deviceScanCodeform=row
          this.disabled=true
        } else {
          this.deviceDialogTitle='添加'
          this.disabled=false
        }
      },
      // 打开详情弹出层
      showDetailDialog (row) {
        this.outerVisible=true
        // 更新相关文件列表
        this.updFileList(row)
        this.form.stockNo=row.stockNo
        this.updatePathForm.id=row.id
      },
      // 更新相关文件列表 参数data是DeviceScanCode对象
      updFileList (data) {
        this.fileList=[]
        if(data.filePath) {
          const pathList=data.filePath.split('***')
          for(let index=1;index<pathList.length;index++) {
            let path=pathList[index]
            let l=path.split('/')
            if(l.length<6) {
              this.fileList=[]
              // todo
              return
            }
            let fileName=l[l.length-1]
            let fileUploadDate=`${l[1]}-${l[2]}-${l[3]}`
            let obj={
              name: fileName,
              uploadDate: fileUploadDate
            }
            this.fileList.push({...data,...obj})
          }
        }
      },
      // 打开文件上传弹出层
      showUploadDialog () {
        this.updatePathForm.action='insert'
        this.innerVisible=true
      },
      // 删除文件地址
      handleDelFilePath (row) {
        this.$confirm('此操作将永久删除该文件, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updatePathForm.action='delete'
          this.updatePathForm.oldFilePath=`***/${row.uploadDate.split('-').join('/')}/${row.stockNo}/${row.name}`
          this.$api.deviceApi.updFilePath(this.updatePathForm,res => {
            // 更新主表格数据
            this.updTableList(res)
            // 更新相关文件列表
            this.updFileList(res)
            this.updatePathForm=Object.assign({},updatePathForm)
            this.updatePathForm.id=row.id
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      },
      // 文件上传弹出层关闭回调
      uploadDialogClosed () {
        // 重置表单
        this.$refs['form'].resetFields()
        this.uploadFileList=[]
      },
      // 更新页面数据
      updTableList (data) {
        for(let index=0;index<this.dataList.length;index++) {
          const element=this.dataList[index];
          if(element.id===data.id) {
            this.dataList.splice(index,1,data)
          }
        }
      },
      // 预览 
      showPreview (row) {
        this.previewVisible=true

        this.$api.deviceApi.getPathByStockNoAndFilename(row.stockNo,row.name,res => {
          console.log(DWSystemSetting.downloadUrl+res)
          this.resourcePreviewURL=pdf.createLoadingTask(DWSystemSetting.downloadUrl+res)
        })
      },
      // 预览窗口关闭回调
      previewDialogClosed () {
        this.resourcePreviewURL=''
        this.numPages=undefined
      },
      uploadExcel () {
        this.$refs['excel-upload-input'].click()
      },
      handleUploadExcelClick (e) {
        const files=e.target.files
        const rawFile=files[0]
        console.log(rawFile)
        if(!rawFile) return
        this.$dialogMethod.showLoading("正在上传Excel文件");
        let formData=new FormData()
        formData.append('file',rawFile)
        this.$api.deviceApi.uploadExcel(formData,res => {
          this.$dialogMethod.closeLoading()
          this.initData()
        })
      },
      showQRCodeImg (row) {
        this.isShowQRCodeImg=true
        this.qrcodeImg='data:image/png;base64,'+row.qrcodeImg
      },
      closeViewer () {
        this.isShowQRCodeImg=false
        this.qrcodeImg=''
      },
      demoClick () {
        this.$api.deviceApi.demo(res => {
          console.log(res)
        })
      }
    }
  }
</script>
<style>
  .archivesBody {
    width: 100%;
    height: 90% !important;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    background-color: white;
  }

  .archiverRigth {
    width: 100%;
    height: 100%;
  }

  .dataAreaTop {
    width: 100%;
    display: flex;
    align-items: center;
    height: 6%;
  }

  .dataAreaBottom {
    width: 98%;
    margin: 0 auto;
    height: 90%;
  }

  .archiverTableOperating {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-dialog__body {
    padding-top: 5px;
    padding-bottom: 20px;
  }

  .el-upload-dragger {
    width: 100%;
  }
</style>